// _-,:/.()&+​01234789abcdefghijklmnopqrstuvwxyz
const FACILITY_NAME_REGEX = new RegExp(/^[-,.()&\w\s]*$/);
const UNDERSCORE = new RegExp(/_/);
/**
 * Validates that a facility name is valid.
 */
export const Validator = {
    name: "facility-name",
    errorMessage: 'This field may only contain alpha-numeric characters, as well "-,.()&".',
    validate: (value) => FACILITY_NAME_REGEX.test(value) && !UNDERSCORE.test(value),
};
